import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ILogisticProduct from '@/interfaces/ILogisticProduct';

@Component
export default class GridProductsColumn extends Vue {
    @Prop({ default: () => [] }) public products: ILogisticProduct;
}
